(function () {
    'use strict';

    var FRAME_INTERVAL = 2000;

    function applyLastSlideOffset(swiper) {
        if (!swiper || !swiper.slides || !swiper.slides.length) {
            return;
        }

        var lastIndex = swiper.slides.length - 1;
        var lastSize = (swiper.slidesSizesGrid && swiper.slidesSizesGrid[lastIndex]) || swiper.slides[lastIndex].offsetWidth;
        var offset = swiper.slides.length < 2 ? 0 : Math.max(0, Math.round(swiper.size - lastSize));

        if (swiper.params.slidesOffsetAfter === offset) {
            return;
        }

        swiper.params.slidesOffsetAfter = offset;
        swiper.update();
    }

    function prefersReducedMotion() {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function showFrame(media, index) {
        var frames = media.querySelectorAll('img');
        frames.forEach(function (img, i) {
            img.classList.toggle('is-visible', i === index);
        });
    }

    function unveilFrames(media) {
        if (!window.lazySizes || !window.lazySizes.loader) {
            return;
        }

        media.querySelectorAll('img.lazyload').forEach(function (img) {
            window.lazySizes.loader.unveil(img);
        });
    }

    function decodeFrame(img) {
        if (img.decode) {
            return img.decode().catch(function () {});
        }

        return Promise.resolve();
    }

    function whenFrameReady(img) {
        return new Promise(function (resolve) {
            var settled = false;

            function finish() {
                if (settled) {
                    return;
                }

                settled = true;
                img.removeEventListener('load', onReady);
                img.removeEventListener('error', onFail);
                img.removeEventListener('lazyloaded', onReady);
                window.clearTimeout(timeout);

                decodeFrame(img).then(resolve, resolve);
            }

            function isReady() {
                if (img.complete && img.naturalWidth > 1) {
                    return true;
                }

                if (img.classList.contains('lazyload') || img.classList.contains('lazyloading')) {
                    return false;
                }

                return false;
            }

            function onReady() {
                if (isReady()) {
                    finish();
                }
            }

            function onFail() {
                finish();
            }

            img.addEventListener('load', onReady);
            img.addEventListener('error', onFail);
            img.addEventListener('lazyloaded', onReady);

            var timeout = window.setTimeout(finish, 4000);
            onReady();
        });
    }

    function whenFramesReady(media) {
        unveilFrames(media);

        var pending = [];
        media.querySelectorAll('img').forEach(function (img) {
            pending.push(whenFrameReady(img));
        });

        return Promise.all(pending);
    }

    function createFrameCycler() {
        var timer = null;
        var activeMedia = null;
        var generation = 0;

        function stop() {
            generation += 1;

            if (timer) {
                window.clearInterval(timer);
                timer = null;
            }

            if (activeMedia) {
                showFrame(activeMedia, 0);
                activeMedia = null;
            }
        }

        function start(slide) {
            stop();

            if (!slide || prefersReducedMotion()) {
                return;
            }

            var media = slide.querySelector('.slider-teaser-slide__media--frames');
            if (!media) {
                return;
            }

            var frames = media.querySelectorAll('img');
            if (frames.length < 2) {
                return;
            }

            var thisGeneration = generation;
            activeMedia = media;

            var index = 0;
            frames.forEach(function (img, i) {
                if (img.classList.contains('is-visible')) {
                    index = i;
                }
            });

            whenFramesReady(media).then(function () {
                if (thisGeneration !== generation || activeMedia !== media) {
                    return;
                }

                timer = window.setInterval(function () {
                    index = (index + 1) % frames.length;
                    showFrame(media, index);
                }, FRAME_INTERVAL);
            });
        }

        return { start: start, stop: stop };
    }

    function initSliderTeaser() {
        if (typeof Swiper === 'undefined') {
            return;
        }

        document.querySelectorAll('.section.section--slider-teaser .slider-teaser-swiper').forEach(function (swiperEl) {
            var section = swiperEl.closest('.section.section--slider-teaser');
            if (!section) {
                return;
            }

            var paginationEl = section.querySelector('.slider-teaser-pagination .swiper-pagination');
            var nextEl = section.querySelector('.slider-teaser-pagination .swiper-button-next');
            var prevEl = section.querySelector('.slider-teaser-pagination .swiper-button-prev');
            var frameCycler = createFrameCycler();

            var config = {
                direction: 'horizontal',
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 24,
                slidesPerGroup: 1,
                speed: 700,
                centeredSlides: false,
                breakpoints: {
                    0: { slidesPerView: 'auto' },
                    576: { slidesPerView: 'auto' },
                    992: { slidesPerView: 'auto' },
                },
            };

            if (paginationEl) {
                config.pagination = { el: paginationEl, clickable: true };
            }
            if (nextEl && prevEl) {
                config.navigation = { nextEl: nextEl, prevEl: prevEl };
            }

            var swiper = new Swiper(swiperEl, config);
            applyLastSlideOffset(swiper);
            frameCycler.start(swiper.slides[swiper.activeIndex]);

            swiper.on('slideChange', function () {
                frameCycler.start(swiper.slides[swiper.activeIndex]);
            });

            swiper.on('resize', function () {
                applyLastSlideOffset(swiper);
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSliderTeaser);
    } else {
        initSliderTeaser();
    }
})();
